import React from 'react'

const Python = () => {
  return (
    <div className='md:w-4/5 mx-auto md:py-10 text-lg'>
      <h1 className='text-2xl font-bold'>Python</h1>
      <br />
      <p className='text-gray-500'>
        Python is one of the most dominant languages in the field of data science today because of its
        flexibility, ease of use in terms of syntax, open-source nature, and ability to handle, clean,
        manipulate, visualize, and analyze data. Python was essentially developed as a programming
        language. However, it offers a wide range of libraries, such as TensorFlow, Seaborn, etc., that
        are attractive for both programmers and data scientists alike. Moreover, there are various other
        tools connected to and built with the help of Python, such as Dask, SciPy, Cython, Matplotlib,
        and HPAT.
      </p>
      <br />
      <p className='font-bold'>
        The following are the key features and usages of Python:
      </p>
      <br />
      <ul className='md:px-10 list-disc pl-5 text-gray-500'>
        <li>
          Used for data cleaning, data manipulation, data visualization, and data analysis.
        </li>
        <br />
        <li>
          Provides a wide range of libraries such as pandas, NumPy, Matplotlib, and many more.

        </li>
        <br />
        <li>
          Helps establish a connection with various other tools such as Cython and Desk.
        </li>
        <br />
        <li>
          Preferred by data scientists, beginners, and experienced professionals.
        </li>
      </ul>
    </div>
  )
}

export default Python